import {
  EditComponentErrorResponse,
  EditComponentError,
} from "@amzn/crowd-front-end-common-library";

function calculateErrorMessage(
  propertyName: string,
  errors: EditComponentError[]
): string {
  const fieldNames = errors
    .filter((error) => error.fieldName !== propertyName)
    .flatMap((error) => error.fieldName);
  return fieldNames.join(", ");
}

/**
 * Default error formatter.
 *
 * @export
 * @param {(EditComponentErrorResponse | undefined)} errorResponse
 * @param {string} propertyName
 * @returns {(string | undefined)}
 */
export default function defaultValidationErrorTextFormatter(
  errorResponse: EditComponentErrorResponse | undefined,
  propertyName: string
): string | undefined {
  if (
    !errorResponse ||
    !errorResponse.errors ||
    errorResponse.errors.length === 0
  ) {
    return undefined;
  }

  for (let i = 0; i < errorResponse.errors.length; i++) {
    const errorGroup = errorResponse.errors[i];

    const match = errorGroup.errors.find(
      (error) => error.fieldName === propertyName
    );
    if (match) {
      return (
        match.message ||
        `Incompatible ${errorGroup.groupLabel} values: ${calculateErrorMessage(
          propertyName,
          errorGroup.errors
        )}`
      );
    }
  }

  return undefined;
}
